const cardItems = [
  {
    title: '动作大片',
    desc: '热血激战、极限追逐，肾上腺素飙升的高清动作电影合集，不卡顿秒播',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20concept%20with%20motion%20blur%20effect%2C%20warm%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20film%20grain%20texture%2C%20dark%20atmospheric%20background%20with%20golden%20highlights%2C%20abstract%20cinematic%20style%2C%20no%20text&width=800&height=500&seq=card-action-01&orientation=landscape',
    tag: '燃爆',
  },
  {
    title: '爱情文艺',
    desc: '浪漫邂逅、温情故事，细腻动人的爱情电影精选，高清画质沉浸体验',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20film%20scene%20with%20soft%20warm%20bokeh%20lighting%2C%20intimate%20composition%2C%20vintage%20cinema%20color%20palette%2C%20gentle%20golden%20hour%20glow%2C%20dreamy%20atmospheric%20mood%2C%20film%20reel%20texture%20overlay%2C%20no%20text%20no%20people&width=800&height=500&seq=card-romance-02&orientation=landscape',
    tag: '催泪',
  },
  {
    title: '悬疑惊悚',
    desc: '烧脑反转、紧张窒息，挑战心理极限的悬疑惊悚佳片，深夜观影首选',
    img: 'https://readdy.ai/api/search-image?query=Horror%20thriller%20movie%20atmosphere%20with%20dramatic%20chiaroscuro%20lighting%2C%20deep%20shadows%20and%20selective%20warm%20highlights%2C%20cinematic%20wide%20shot%2C%20suspenseful%20mood%2C%20film%20grain%20texture%2C%20dark%20mysterious%20composition%2C%20no%20text&width=800&height=500&seq=card-horror-03&orientation=landscape',
    tag: '烧脑',
  },
  {
    title: '喜剧欢乐',
    desc: '捧腹大笑、轻松解压，治愈系喜剧电影大合集，高清不卡随心看',
    img: 'https://readdy.ai/api/search-image?query=Comedy%20film%20concept%20with%20bright%20warm%20lighting%20setup%2C%20playful%20composition%2C%20golden%20hour%20backlight%2C%20cinematic%20aspect%20ratio%2C%20joyful%20atmosphere%2C%20soft%20focus%20background%2C%20no%20text%20no%20people&width=800&height=500&seq=card-comedy-04&orientation=landscape',
    tag: '解压',
  },
  {
    title: '科幻奇幻',
    desc: '未来世界、异想奇观，震撼视效的科幻奇幻电影盛宴，高清影视畅享',
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20aesthetic%20with%20sleek%20modern%20composition%2C%20warm%20amber%20and%20cool%20steel%20contrast%2C%20cinematic%20lighting%2C%20futuristic%20atmosphere%20with%20classic%20film%20grain%2C%20dramatic%20scale%2C%20no%20text&width=800&height=500&seq=card-scifi-05&orientation=landscape',
    tag: '震撼',
  },
  {
    title: '动漫剧场',
    desc: '经典番剧、剧场版精选，动画爱好者的追番天堂，高清秒播不卡顿',
    img: 'https://readdy.ai/api/search-image?query=Animated%20film%20aesthetic%20with%20rich%20warm%20color%20palette%2C%20cinematic%20lighting%20setup%2C%20magical%20atmosphere%2C%20soft%20golden%20glow%2C%20artistic%20composition%2C%20film%20texture%20overlay%2C%20no%20text%20no%20characters&width=800&height=500&seq=card-anime-06&orientation=landscape',
    tag: '热门',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          热门分类
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          精选六大观影分类，快速找到你想看的免费电影与高清剧集
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`夜猫电影院${item.title}分类 - ${item.desc}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).style.minHeight = '0';
                    (target.parentElement as HTMLElement).classList.add('hidden');
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center gap-2 text-primary-600 text-sm font-medium">
                  <span className="whitespace-nowrap">立即观看</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}